import { eventChannel, type EventChannel } from 'redux-saga';
import { put, select, takeEvery } from 'redux-saga/effects';

import { actions as messagesActions } from '@/modules/messages';

import { Status } from '../../constants';
import { getConnectionStatus } from '../../utils/getConnectionStatus';
import { updateNetworkStatus } from '../actions';
import { networkStatusSelector } from '../selectors';

function* createConnectionChannel() {
    let prevStatus: Status = yield select(networkStatusSelector);

    return eventChannel<Status>(emit => {
        function handleConnectionStatusChange() {
            const status = getConnectionStatus();
            if (status !== prevStatus) {
                emit(status);
                prevStatus = status;
            }
        }

        window.addEventListener('online', handleConnectionStatusChange);
        window.addEventListener('offline', handleConnectionStatusChange);

        return () => {
            window.removeEventListener('online', handleConnectionStatusChange);
            window.removeEventListener('offline', handleConnectionStatusChange);
        };
    });
}

const options = {
    duration: 3.5,
};

function* handleConnectionChange(status: Status) {
    if (status === Status.OFFLINE) {
        yield put(messagesActions.displayInfoMessage({ message: { id: 'network.offline' }, options }));
    } else {
        yield put(messagesActions.displayInfoMessage({ message: { id: 'network.online' }, options }));
    }
    yield put(updateNetworkStatus(status));
}

export default function* networkConnection() {
    const connectionChannel: EventChannel<Status> = yield createConnectionChannel();

    yield takeEvery(connectionChannel, handleConnectionChange);
}
